import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-description-requirement',
	templateUrl: './description-requirement.component.html',
	styleUrls: ['./description-requirement.component.css'],
})
export class DescriptionRequirementComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/product/description_requirement/';
	protected parentComponent: string;
	descriptionHeaders: Array<any>;
	productKinds: Array<any>;
	productKind;
	descriptionRequirement;
	codebook;
	editHeader = true;
	defaultProductKind: number;
	protected itemsBeforeDataLoad = 3;
	protected pageTitleGenerate(): string {
		this.productKind = [this.productKinds.find((obj) => obj.id == this.defaultProductKind)];
		return `Słowniki -> 
			${this.codebook.name}
			 -> 
			${this.productKind[0].name}
			 -> 
			${this.data.descriptionHeader.name}
			(ID:
			${this.data.id}
			)`;
	}

	data = {
		id: null,
		productKind: null,
		descriptionHeader: {
			comment: '',
			header: '',
			id: null,
			multimedia: null,
			name: '',
		},

		isRequired: false,
	};

	protected convertData(data: any) {
		if (this.productKinds !== undefined) {
			this.productKind = [this.productKinds.find((obj) => obj.id == this.defaultProductKind)];
		}
		return data;
	}

	protected submitBefore(): void {
		this.parentComponent = 'codebook/product_kind/description_requirement/' + this.defaultProductKind;
	}

	protected submitAfter(): void {
		this.router.navigate([this.parentComponent]);
	}

	protected submitConvert(data) {
		return {
			id: data.id,
			productKind: this.defaultProductKind,
			descriptionHeader: data.descriptionHeader.id,
			isRequired: data.isRequired,
		};
	}

	protected getApiUrl(): string {
		return '/product/description_requirement/' + this.data.id + '/';
	}

	protected loadBefore(): void {
		this.defaultProductKind = Number(this.route.snapshot.params['productKind']);
		this.bag.get('/product/kind/', (result, error) => {
			this.productKinds = result.results;
			this.loadData();
		});
		this.bag.get('/product/description_requirement/?limit=9999', (result, error) => {
			this.descriptionRequirement = result.results;
			const usedDescriptionHeaders = result.results
				.filter((obj) => obj.productKind == this.defaultProductKind)
				.map((obj) => obj.descriptionHeader);
			this.bag.get('/description_header/?limit=9999', (result, error) => {
				if (this.pageFunction == 'add') {
					this.descriptionHeaders = result.results.filter(
						(obj) => !usedDescriptionHeaders.find((rm) => rm.id == obj.id),
					);
				} else {
					this.descriptionHeaders = result.results;
				}
				this.loadData();
			});
		});
		this.bag.get('/codebook/1/', (result, error) => {
			this.codebook = result;
			this.loadData();
		});

		if (this.pageFunction == 'edit') {
			this.editHeader = false;
		}
	}
}
